import React, { ChangeEvent, useEffect, useState } from "react";
import styles from "./style.module.scss";
import tyreSelectStyles from "../../../components/TPMS/TPMSJaguarPage/TyreSelect/style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import {
  setSelectedCar,
  setEditModeState,
  setShowPlots,
} from "../../../state/tpmsReducer";
import { useDispatch } from "react-redux";
import { TyreConfig } from "../../../types";
import Loading from "../../../components/TPMS/Loading";
import TyreGroup from "../../../components/TPMS/TPMSJaguarPage/TyreGroup";
import TyreGroupCharts from "../../../components/TPMS/TPMSJaguarPage/TyreGroupCharts";
import { store } from "../../../state";
import { BiSolidCog } from "react-icons/bi";
import ConfigDialog from "../../../components/TPMS/TPMSJaguarPage/ConfigDialog";
import TyreGroupAxisControls from "../../../components/TPMS/TPMSJaguarPage/TyreGroupAxisControls";
import TPMSDataManager from "../../../components/DataManagers/TPMSDataManager";
import TyreSelect from "../../../components/TPMS/TPMSJaguarPage/TyreSelect";
import { MutateSetSelectedTyres } from "../../../utils/graphql/hooks/TPMSHooks";
import {
  CacheTableButton,
  CacheTableContent,
} from "../../../components/TPMS/TPMSJaguarPage/CacheTable";
import cacheTableStyles from "../../../components/TPMS/TPMSJaguarPage/CacheTable/style.module.scss";
import AuthenticatedLayout from "../../../components/Layout/authenticatedLayout";
import ImportsDataManager from "../../../components/DataManagers/ImportsDataManager";

function toggleEditMode(newState: boolean) {
  store.dispatch(setEditModeState(newState));
}

function TPMSJaguarPage() {
  const setSelectedTyresMutation = MutateSetSelectedTyres();
  const wsConnected = useSelector(
    (state: RootState) => state.admin.wsConnected,
  );
  const isLoading = useSelector((state: RootState) => state.tpms.loadingState);
  const selectedCar = useSelector((state: RootState) => state.tpms.selectedCar);
  const tpmsConfig = useSelector((state: RootState) => state.tpms.tpmsConfig);
  console.log("tpmsConfig", tpmsConfig);
  const jagDrivers = useSelector(
    (state: RootState) => state.imports.derivedImportData.strategy.jagDrivers,
  );
  const driverInfo = useSelector(
    (state: RootState) => state.imports.derivedImportData.strategy.driverInfo,
  );
  // const tpmsReceiverConnected = useSelector(
  //   (state: RootState) => state.tpms.tpmsReceiverConnected
  // );
  const editModeState = useSelector(
    (state: RootState) => state.tpms.editModeState,
  );
  const [isConfigDialogOpen, setConfigDialogOpen] = useState(false);
  const [isTableOpen, setTableOpen] = useState(false);

  const forcedDrivers = [jagDrivers.redCar, jagDrivers.blueCar, "DEV"]; //these drivers will always appear even if not in the config
  let uniqueDrivers = [] as Array<string>;
  if (tpmsConfig) {
    const compare = function (a: string, b: string) {
      return parseInt(a) - parseInt(b);
    };
    uniqueDrivers = Array.from(
      new Set(tpmsConfig["tyres"].map((item: TyreConfig) => item.carId)),
    ).sort(compare);
  }

  for (const x of forcedDrivers) {
    if (!uniqueDrivers.includes(x)) {
      uniqueDrivers.push(x);
    }
  }

  uniqueDrivers = uniqueDrivers.filter((x) => x !== "DEV");
  uniqueDrivers.push("DEV");

  const dispatch = useDispatch();
  useEffect(() => {
    if (
      uniqueDrivers.length > 0 &&
      (!selectedCar || !uniqueDrivers.includes(selectedCar))
    ) {
      const defaultDriver = uniqueDrivers[0];
      dispatch(setSelectedCar(defaultDriver));
    }
  });

  const handleOptionChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedCar = event.target.value;
    dispatch(setSelectedCar(selectedCar));
  };

  const toggleShowPlots = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    dispatch(setShowPlots(value));
  };

  const showPlots = useSelector((state: RootState) => state.tpms.showPlots);
  // const showPlots = true;

  const isReady = isLoading || !wsConnected || !tpmsConfig ? false : true;

  const barColour = selectedCar
    ? driverInfo[selectedCar]?.driverHighlightColourAlt
    : undefined;

  const [selectMode, setSelectMode] = useState(false);
  const [selectedTyres, setSelectedTyres] = useState<string[]>([]);

  const configOptions = isReady ? (
    <div className={styles.header}>
      <form className={styles.driverSelectionForm}>
        {uniqueDrivers.map((x) => (
          <label key={x} className={styles.formControl}>
            <input
              onChange={handleOptionChange}
              type="radio"
              value={x}
              name="car"
              checked={selectedCar === x}
            />
            {x}
          </label>
        ))}
      </form>
      <div className={styles.rightSideButtons}>
        <CacheTableButton onOpen={() => setTableOpen(true)} />
        <TyreSelect
          onSelectModeChange={setSelectMode}
          selectMode={selectMode}
          disabled={editModeState}
        />
        <div className={styles.showPlotsContainer}>
          <div>Show Plots: </div>
          <input
            type="checkbox"
            checked={showPlots}
            onChange={toggleShowPlots}
          ></input>
        </div>
        {<TyreGroupAxisControls disabled={!showPlots} />}
        <button
          className={styles.configButton}
          onClick={() => {
            setConfigDialogOpen(true);
          }}
        >
          <BiSolidCog></BiSolidCog>
        </button>
        <button
          className={`${styles.editModeButton} ${
            editModeState ? styles.editModeActive : styles.editModeInactive
          }`}
          onClick={() => toggleEditMode(!editModeState)}
          disabled={selectMode}
        >
          Edit Mode {editModeState ? "ON" : "OFF"}
        </button>
      </div>
    </div>
  ) : null;

  useEffect(() => {
    setSelectMode(false);
    setSelectedTyres([]);
  }, [selectedCar]);

  return (
    <AuthenticatedLayout
      title={"TPMS Jaguar"}
      configOptions={configOptions}
      barColour={barColour}
      showJaguarLogo={false}
    >
      {isTableOpen && (
        <div className={cacheTableStyles.tableModalContainer}>
          <div className={cacheTableStyles.tableModal}>
            <CacheTableContent />
            <button
              className={cacheTableStyles.closeButton}
              onClick={() => setTableOpen(false)}
            >
              Close
            </button>
          </div>
          <div
            className={cacheTableStyles.backgroundBlur}
            onClick={() => setTableOpen(false)}
          ></div>
        </div>
      )}
      <TPMSDataManager />
      <ImportsDataManager />
      <div className={styles.container}>
        {selectMode && selectedTyres.length > 0 && (
          <div className={tyreSelectStyles.confirmButtonContainer}>
            <button
              className={tyreSelectStyles.confirmButton}
              onClick={async () => {
                console.log(
                  "Sending selected sensor IDs to backend:",
                  selectedTyres,
                );
                if (selectedTyres.length > 0) {
                  try {
                    await setSelectedTyresMutation({
                      variables: { tyreIds: selectedTyres },
                    });
                  } catch (_) {
                    // H
                  }
                }
                setSelectedTyres([]);
                setSelectMode(false);
              }}
            >
              Confirm Selection
            </button>
          </div>
        )}
        <div className={styles.weatherDisplay}>
          {tpmsConfig?.tAmbient !== undefined
            ? `${tpmsConfig.tAmbient.toFixed(1)} °C`
            : ""}
        </div>
        {isReady ? (
          <>
            <div
              className={`${
                showPlots ? styles.gridWithPlots : styles.gridWithoutPlots
              } ${styles.grid}`}
            >
              <div className={styles.gridFrontTyres}>
                <TyreGroup
                  group="Front"
                  selectMode={selectMode}
                  selectedTyres={selectedTyres}
                  setSelectedTyres={setSelectedTyres}
                />
              </div>
              <div className={styles.gridRearTyres}>
                <TyreGroup
                  group="Rear"
                  selectMode={selectMode}
                  selectedTyres={selectedTyres}
                  setSelectedTyres={setSelectedTyres}
                />
              </div>
              <div className={styles.gridFrontTyresPlot}>
                {showPlots ? <TyreGroupCharts group="Front" /> : <></>}
              </div>
              <div className={styles.gridRearTyresPlot}>
                {showPlots ? <TyreGroupCharts group="Rear" /> : <></>}
              </div>
            </div>
          </>
        ) : (
          <>
            <Loading />
          </>
        )}
      </div>
      <ConfigDialog
        isOpen={isConfigDialogOpen}
        showDialog={setConfigDialogOpen}
      ></ConfigDialog>
    </AuthenticatedLayout>
  );
}

export default TPMSJaguarPage;
